import { render } from "./AcceptanceProDetails.vue?vue&type=template&id=1c9474d6&scoped=true"
import script from "./AcceptanceProDetails.vue?vue&type=script&lang=js"
export * from "./AcceptanceProDetails.vue?vue&type=script&lang=js"

import "./AcceptanceProDetails.vue?vue&type=style&index=0&id=1c9474d6&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9474d6"]])

export default __exports__